
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { IUser } from "@/model/User/UserInterface";
import { EPermissionActions } from "@/model/EPermissionActions";
import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";
import {IOnOffHandlers} from "bonomo";
import {IAuthUserData} from "@/store/modules/authModule";

const lockerCompanyModule = namespace("lockerCompanyModule");
const userModule = namespace("userModule");
const authModule = namespace("authModule");

@Component({
  components: { LockerSearch },
})
export default class ULockerCompany extends Vue {
  @lockerCompanyModule.Action("fetchLockersLockerCompanies")
  fetchLockersLockerCompanies!: (lockerId: number) => void;
  @lockerCompanyModule.Getter("lockersLockerCompanies")
  lockerCompanies!: ILockerCompany[]

  @userModule.Action("setLockerCompany")
  setLockerCompany!: (data: { user_id: number, locker_company_id: number }) => void;

  @authModule.Getter("userData")
  authUser!: IAuthUserData;

  @Prop()
  user!: IUser;

  selectedId: number = 0;
  editing: boolean = false;
  loading: boolean = false;
  submitting: boolean = false;
  subscribes: IOnOffHandlers = {};

  get isSelf(): boolean {
    return '' + this.user.id === '' + this.authUser.id;
  }

  get canEdit(): boolean {
    return this.$canAction(EPermissionActions.ACTION_USERS_UPDATE)
      || (this.isSelf && this.$canAction(EPermissionActions.ACTION_USERS_ALLOW_EDIT_HIMSELF));
  }

  get companyItems() {
    const lockerCompanies = this.lockerCompanies;
    const usersLockerCompany = this.usersLockerCompany;
    const ret = lockerCompanies.map(lockerCompany => ({
      text: lockerCompany.description + ' (#' + lockerCompany.id + ')',
      value: lockerCompany.id,
    }));
    // add users current company even if it's not on the locker currently. It cannot be saved anyway and at least we're showing that company too
    if (usersLockerCompany && !ret.find(each => each.value == usersLockerCompany.id)) {
      ret.push({
        text: usersLockerCompany.description || '-',
        value: usersLockerCompany.id,
      });
    }
    ret.sort((a, b) => a.text.localeCompare(b.text));
    // add empty option
    ret.unshift({ text: '-', value: 0 });
    return ret;
  }

  get saveEnabled(): boolean {
    return this.selectedId != this.usersLockerCompany.id;
  }

  get usersLockerCompany(): ILockerCompany {
    const lockerCompany = this.user.lockerCompany;
    return lockerCompany ? lockerCompany : {id: 0, description: '-'} as ILockerCompany;
  }

  created() {
    this.loading = true;
    this.fetchLockersLockerCompanies(this.user.locker_id);
    this.subscribes = this.$ons({
      'backend.call.OK.lockersLockerCompaniesLoaded': () => {
        this.loading = false;
      },
      'backend.call.KO.lockersLockerCompaniesLoaded': () => {
        this.loading = false;
      },
      'backend.call.OK.lockerCompanySet': this.onSubmitOK,
      'backend.call.KO.lockerCompanySet': this.onSubmitKO,
    })
    this.selectedId = this.user.lockerCompany ? this.user.lockerCompany.id || 0 : 0;
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  onCancel() {
    this.editing = false;
    this.selectedId = this.user.lockerCompany!.id || 0;
  }

  onEdit() {
    this.editing = true;
  }

  onSave() {
    this.submitting = true;
    this.setLockerCompany({user_id: this.user.id, locker_company_id: this.selectedId });
  }

  onSubmitOK() {
    this.editing = false;
    this.submitting = false;
  }

  onSubmitKO() {
    this.submitting = false;
  }

}
